import { Dispatch } from "redux";
import {
  ERROR_LOADING_DNS_RECORD,
  GET_ALL_DNS_RECORD,
  RESET_DATA,
  START_LOADING_DNS_RECORD,
  STOP_LOADING_DNS_RECORD,
} from "./action-types";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";

export const fetchDNSRecordAction =
  (id: number) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_DNS_RECORD });
    try {
      const { data } = await apiLibrary.Brands.getDnsRecords(id);

      dispatch({
        type: GET_ALL_DNS_RECORD,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_DNS_RECORD });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_DNS_RECORD });
      // dispatch(loadingState(false))
    }
  };
